import lodash from "lodash";
import Base from "../base.store";
import request from "../../../../utils/request";
import { filter } from "../../../../utils/search";
import moment from "moment";

const baseUrl = '/api/v1/transaction/user-companies'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        newRegister(context, { data, config }) {
            return request.put(`${baseUrl}/newRegister`, data, { ...config })
        },
        requiredUsernameCheck(context, { data, config }) {
            return base.request.post(`${baseUrl}/required/username`, data, { ...config })
        },
        requiredIdCardCheck(context, { data, config }) {
            return base.request.post(`${baseUrl}/required/idCard`, data, { ...config })
        },
        requiredEmailCheck(context, { data, config }) {
            return base.request.post(`${baseUrl}/required/email`, data, {...config})
        },
        findAllMyCompanies(context, { userId, searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const select = ['*', 'refCompany.*', 'refCompany.refFactoryAddrTh.*', 'refCompany.refFactoryAddrEn.**', 'refCompany.refGmpLv.*']
            const wheres = [
                { name: 'refUser.id', operator: '=', type: "UUID", value: userId },
                { name: "refCompany.isActive", type: "Boolean", operator: '=', value: true },
                { name: "refCompany.refStatus.key", type: "String", operator: '=', value: 'Approve' },
                { name: "refCompany.thNo", type: "String", isNot: true, operator: '=', value: null },
            ]
            const sort = [{ name: 'refCompany.tax', type: 'ASC' }, { name: 'refCompany.nameTh', type: 'ASC' }]
            const whereFilter = [
                { name: 'tax', operator: 'like', type: "String", value: searchQuery },
                { logic: 'OR', name: 'nameTh', operator: 'like', type: "String", value: searchQuery },
                { logic: 'OR', name: 'thNo', operator: 'like', type: "String", value: searchQuery },
            ]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list: list.map(d => d.refCompany), where: whereFilter })
            }
            return context.dispatch('findAll', { criteria: { select, where: wheres, sort} })
                .then(list => filter({ list: list.map(d => d.refCompany), where: whereFilter }))
        },
        reportInfo(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/info`, data, { ...config, responseType: "blob" });
        }
    },
    mutations: {
        ...base.mutations
    },
}
